module.exports = __webpack_public_path__ + "static/media/scottkimcarol93.e8303171.png";